module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page"
  }, [_c('div', {
    staticClass: "two-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.orderWeight,
      "table_style": 2,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单重量' : '订单量',
      "canEdit": _vm.canEdit,
      "row_num": 10,
      "show_pagination": true
    },
    on: {
      "update:canEdit": function($event) {
        _vm.canEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }), _vm._v(" "), _c('mii-table', {
    attrs: {
      "datas": _vm.orderVolume,
      "table_style": 1,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单体积' : '有效容积',
      "canEdit": _vm.canEdit,
      "row_num": 10,
      "show_pagination": true
    },
    on: {
      "update:canEdit": function($event) {
        _vm.canEdit = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan-width"
  }), _vm._v(" "), _c('div', {
    staticClass: "one-content"
  }, [_c('week-data', {
    attrs: {
      "datas": _vm.orderDays,
      "title": "订货时间"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b7750ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/tobacco/source_data_to.vue
// module id = 790
// module chunks = 1